import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGodotengineComponent } from './simple-icons-godotengine.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGodotengineComponent ],
    exports:      [ SimpleIconsGodotengineComponent ],
    bootstrap:    []
})
export class SimpleIconsGodotengineModule {}
